const moduleName: string = "AUDIT/";

export const GET_AUDIT_START: string = `${moduleName}GET_AUDIT_START`;
export const GET_AUDIT_SUCCESS: string = `${moduleName}GET_AUDIT_SUCCESS`;
export const SAVE_AUDIT_OPERATOR_INFO_SUCCESS: string = `${moduleName}SAVE_AUDIT_OPERATOR_INFO_SUCCESS`;
export const CLEAR_AUDITS_SUCCESS: string = `${moduleName}CLEAR_AUDITS_SUCCESS`;
export const GET_AUDIT_ERROR: string = `${moduleName}GET_AUDIT_ERROR`;

export const SAVE_AUDIT_TAGS_SUCCESS: string = `${moduleName}SAVE_AUDIT_TAGS_SUCCESS`;